import type { Root } from 'mdast';
import {
  gfmStrikethroughFromMarkdown,
  gfmStrikethroughToMarkdown,
} from 'mdast-util-gfm-strikethrough';
import { gfmStrikethrough } from 'micromark-extension-gfm-strikethrough';
import type { Plugin } from 'unified';

/**
 * Remark plugin that adds support for GFM strikethrough syntax (~~text~~)
 */
const remarkStrikethrough: Plugin<[], Root> = function () {
  const data = this.data() as Record<string, unknown[]>;

  // Add micromark extension for parsing strikethrough syntax
  if (!data.micromarkExtensions) {
    data.micromarkExtensions = [];
  }
  data.micromarkExtensions.push(gfmStrikethrough());

  // Add mdast extension for converting parsed tokens to AST nodes
  if (!data.fromMarkdownExtensions) {
    data.fromMarkdownExtensions = [];
  }
  data.fromMarkdownExtensions.push(gfmStrikethroughFromMarkdown());

  // Add mdast extension for serializing AST nodes back to markdown
  if (!data.toMarkdownExtensions) {
    data.toMarkdownExtensions = [];
  }
  data.toMarkdownExtensions.push(gfmStrikethroughToMarkdown());
};

export default remarkStrikethrough;
